import {useMemo} from "react"
import {useAppContext} from "./useAppContext";
import {RecentlyViewedModel} from "../models/view/recentlyViewedModel";
import {recentlyViewed} from "../utils/helpers";

export const useRecentlyViewedProductsCarousel = () => {
    const {productId} = useAppContext();

    const recentlyViewedProductIds = useMemo(() => recentlyViewed().filter(id => id !== productId), [productId]);

    return new RecentlyViewedModel(recentlyViewedProductIds);
}